export const userCompanySelector = (state: any) =>
  state.UserReducer.userCompany;

export const userCompanyChooseSelector = (state: any) =>
  state.UserReducer.userCompanyChoose;
